module.exports = __webpack_public_path__ + "img/logo-app.5ff7a67a.png";